import ApprovalMasterVendor from "./ApprovalMasterVendor";

export default ApprovalMasterVendor;
